<template>
  <div class="tw:overflow-y-auto tw:overflow-x-hidden tw:flex tw:flex-col">
    <ul class="tw:flex tw:flex-col tw:flex-1 tw:overflow-y-auto tw:max-h-64">
      <li
        v-for="organisation in organisations"
        :key="organisation.id"
        @click.prevent="selectOrganisation(organisation)"
        @keydown.prevent="selectOrganisation(organisation)"
      >
        <label
          :for="organisation.id"
          :title="organisation.name"
          tabindex="0"
          class="tw:flex tw:items-center tw:m-0 tw:relative tw:cursor-pointer tw:px-4 tw:py-3 tw:focus:outline-hidden tw:leading-4 tw:max-w-full tw:h-12"
          :class="selectedOrganisationInSwitcher?.id === organisation.id ? 'tw:bg-blue-100 tw:hover:bg-blue-100' : ''"
          :ref="el => setSelectedRef(el, organisation.id)"
        >
          <div class="tw:ml-3 tw:overflow-hidden tw:flex-1">
            <p class="tw:truncate tw:text-sm tw:color-black tw:font-bold">
              {{ organisation.name }}
            </p>
            <p class="tw:truncate tw:text-xxs tw:text-gray-700"><strong>ID:</strong> {{ organisation.id }}</p>
          </div>
          <ChevronRight class="tw:size-6" />
        </label>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import ChevronRight from '@/components/icons/ChevronRight.svg?component'

import { useScrollTo } from '@/composables/useScrollTo'

const { register, scrollTo } = useScrollTo()
const props = defineProps({
  selectedOrganisationInSwitcher: {
    type: Object,
    required: true,
  },
})

const selectedOrgRef = ref(null)
const emit = defineEmits(['organisationInSwitcherClick'])

const store = useStore()
const organisations = computed(() => store.state.session.organisations)

const selectOrganisation = organisation => {
  emit('organisationInSwitcherClick', organisation)
}

const setSelectedRef = (el, itemId) => {
  if (props.selectedOrganisationInSwitcher.id === itemId) {
    selectedOrgRef.value = el
    register('selectedOrganisation', selectedOrgRef.value)
  }
}

onBeforeUnmount(() => {
  register('selectedOrganisation', null)
})

onMounted(() => {
  scrollTo('selectedOrganisation')
})
</script>

<style scoped>
.id-text {
  font-size: 10px;
}
</style>
